import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from "axios";
import '../../App.css';
import '../styles/NltxTransactions.css'
import ChartLine from '../js/ChartLine';
import ChartBarNominal from '../js/ChartBarNominal';
import ChartPie from '../js/ChartPie';
import ChartGauge from '../js/ChartGauge';
import ChartDonut from '../js/ChartDonut';

export default function NltxTransactions() {
    useEffect(() => {
        document.title = "Analytics | Transactions"; // Set the tab name
    }, []);

    const [dataCounts, setDataCounts] = useState({
        requestsTotal: 0,
        requestsOpen: 0,
        requestsInProgress: 0,
        requestsDone: 0
    });

    const [updateTrigger, setUpdateTrigger] = useState(false);
    
    const abbreviateNumber = (number) => {
        if (number >= 1_000_000) {
            return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'; // Abbreviate to 'M' for millions
        } else if (number >= 1_000) {
            return (number / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'; // Abbreviate to 'K' for thousands
        }
        return number.toString(); // Return the number as a string if under 1,000
    };

    useEffect(() => {
        const fetchDataCounts = async () => {
          try {
            const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/your-endpoint.php'); // TODO refer to api folder in htdocs
            setDataCounts({
              requestsTotal: abbreviateNumber(response.data.requestsTotal),
              requestsOpen: abbreviateNumber(response.data.requestsOpen),
              requestsInProgress: abbreviateNumber(response.data.requestsInProgress),
              requestsDone: abbreviateNumber(response.data.requestsDone)
            });
          } catch (error) {
            //console.error("Error fetching data counts:", error);
          }
        };
    
        fetchDataCounts();
    }, [updateTrigger]); // Only calls when updateTrigger changes

    const refreshTopData = () => {
        setUpdateTrigger(!updateTrigger);
    };  

    const navigate = useNavigate();
    
    const data1 = [
        {date: new Date("2024-06-01"), value: 30},
        {date: new Date("2024-07-01"), value: 70},
        {date: new Date("2024-08-01"), value: 92}
    ]

    const data2 = [
        {date: new Date("2024-06-01"), value: 44},
        {date: new Date("2024-07-01"), value: 64},
        {date: new Date("2024-08-01"), value: 79}
    ]

    return (
        <div>
        <div className="analytics-heading">
            <strong className='text'>Transaction Analytics</strong>
        </div>
        <section className='dash_overview'>
            <article className='stat_box standalone'>
                <h6 className='title analytics-card' analytics-card>Total&nbsp;Requests</h6>
                <p className='title body analytics-card'>{dataCounts.requestsTotal}</p>
            </article>

            <article className='stat_box standalone'>
                <h6 className='title analytics-card'>Open&nbsp;Requests</h6>
                <p className='title body analytics-card'>{dataCounts.requestsOpen}</p>    
            </article>

            <article className='stat_box standalone'>
                <h6 className='title analytics-card'>In&nbsp;Progress&nbsp;Requests</h6>
                <p className='title body analytics-card'>{dataCounts.requestsInProgress}</p>
            </article>

            <article className='stat_box standalone'>
                <h6 className='title analytics-card'>Completed&nbsp;Requests</h6>
                <p className='title body analytics-card'>{dataCounts.requestsDone}</p>
            </article>
        </section>

        <section className='dash_overview' style={{ marginTop: '20px' }}>
            <article className='stats'>
                <h5 className='title'>Requests&nbsp;In&nbsp;Progress&nbsp;VS&nbsp;Completed</h5>
                <article className='stat_box'>
                    <ChartLine dataProps1={data1} dataProps2={data2} nameProps1='In Progress' nameProps2='Completed' />
                </article>
            </article>
            <article className='stats'>
                <h5 className='title'>Requests&nbsp;by&nbsp;Client&nbsp;Type</h5>
                    <ChartBarNominal />
            </article>
        </section>
        
    </div>
    )
}